import { memo } from "react";

import { ListItem, ListItemProps } from "./list-item";
import { Row, TextBody } from "../lib";
import { colors, createStyles } from "../theme";

type Props = ListItemProps<string> & {
  description: string;
};

export const PlaceListItem = memo(function PlaceListItem({
  description,
  ...rest
}: Props) {
  return (
    <ListItem {...rest} style={$.container}>
      <Row.L style={$.inner}>
        <TextBody>{description}</TextBody>
      </Row.L>
    </ListItem>
  );
});

const $ = createStyles({
  container: {
    p: "0",
    px: "4",
  },
  inner: {
    borderBottomColor: colors.outline,
    borderBottomWidth: 1,
    py: "4",
  },
});
